<template>
  <div>
    <section class="section">
      <div class="container content">
        <h1 class="title">{{ $t("documentation.title") }}</h1>

        <h2>{{ $t("documentation.dataFieldFiles") }}</h2>
        <p>
          {{ $t("documentation.dataFieldFilesDescription") }}
        </p>

        <p>
          <a
            :href="$localized('fieldDataTemplate')"
            @click="
              $track(
                'SM-Downloads',
                'SM5-documentation-download',
                'SM5-FieldData-template',
              )
            "
            >{{ $t("documentation.dataFieldFiles") }}</a
          >
        </p>
        <p>
          <a
            :href="$localized('fieldDataTemplateGPS')"
            @click="
              $track(
                'SM-Downloads',
                'SM5-documentation-download',
                'SM5-GPSFieldData-template',
              )
            "
            >{{ $t("documentation.dataFieldGPSFiles") }}</a
          >
        </p>

        <h2>{{ $t("documentation.scripts") }}</h2>
        <p>{{ $t("documentation.scriptsDescription") }}:</p>
        <p>
          <a
            :href="$localized('rawFilePython')"
            @click="
              $track(
                'SM-Downloads',
                'SM5-documentation-download',
                'SM5-Python-Script',
              )
            "
            >{{ $t("documentation.scriptPython") }}</a
          >
        </p>

        <h2>{{ $t("documentation.papers") }}</h2>
        <p>{{ $t("documentation.papersDescription") }}:</p>
        <p>
          Somarriba, E., Zamora, R., Barrantes, J. et al. ShadeMotion: tree
          shade patterns in coffee and cocoa agroforestry systems. Agroforest
          Syst (2022).
          <a
            href="https://doi.org/10.1007/s10457-022-00784-1"
            target="_blank"
            @click="
              $track('SM-Downloads', 'SM5-documentation-download', 'SM5-Paper')
            "
            >https://doi.org/10.1007/s10457-022-00784-1</a
          >
        </p>
        <!--
      <p>
        <a href="#">{{ $t("documentation.scriptR") }}</a>
      </p>
      --></div>
    </section>
    <section v-if="showVideos" class="section">
      <div class="container content">
        <h1 class="title">{{ $t("documentation.videos.title") }}</h1>

        <h2>{{ $t("documentation.videos.intro") }}</h2>
        <video
          controls
          @play="
            $track('SM-Downloads', 'SM5-documentation-videos', 'SM5-Intro')
          "
        >
          <source src="/files/video/shademotion.mp4" type="video/mp4" />
        </video>

        <h2>{{ $t("documentation.videos.demo") }}</h2>
        <video
          controls
          @play="$track('SM-Downloads', 'SM5-documentation-videos', 'SM5-Demo')"
        >
          <source src="/files/video/Demo.mp4" type="video/mp4" />
          <track
            label="Español"
            kind="subtitles"
            srclang="es"
            src="/files/video/Demo.vtt"
          />
        </video>

        <h2>{{ $t("documentation.videos.rawData") }}</h2>
        <video
          controls
          @play="
            $track(
              'SM-Downloads',
              'SM5-documentation-videos',
              'SM5-Datos-Crudos',
            )
          "
        >
          <source src="/files/video/Datos-Crudos.mp4" type="video/mp4" />
          <track
            label="Español"
            kind="subtitles"
            srclang="es"
            src="/files/video/Datos-Crudos.vtt"
          />
        </video>

        <h2>{{ $t("documentation.videos.statData") }}</h2>
        <video
          controls
          @play="
            $track(
              'SM-Downloads',
              'SM5-documentation-videos',
              'SM5-Datos-Estadisticos',
            )
          "
        >
          <source src="/files/video/Datos-Estadisticos.mp4" type="video/mp4" />
          <track
            label="Español"
            kind="subtitles"
            srclang="es"
            src="/files/video/Datos-Estadisticos.vtt"
          />
        </video>

        <h2>{{ $t("documentation.videos.comp") }}</h2>
        <video
          controls
          @play="
            $track('SM-Downloads', 'SM5-documentation-videos', 'SM5-Computo')
          "
        >
          <source src="/files/video/Computo.mp4" type="video/mp4" />
          <track
            label="Español"
            kind="subtitles"
            srclang="es"
            src="/files/video/Computo.vtt"
          />
        </video>

        <h2>{{ $t("documentation.videos.how") }}</h2>
        <video
          controls
          @play="$track('SM-Downloads', 'SM5-documentation-videos', 'SM5-How')"
        >
          <source src="/files/video/shademotion.mp4" type="video/mp4" />
        </video>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideos: location.search === "?mode=demo",
    };
  },
};
</script>
